<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-3"></div>
    <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.close(false)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div>
        <h4 class="text-uppercase">{{'IDS_CONFIRM_RAISE' | translate}}</h4>
    </div>
    <div class="mt-3">
        <label>
            <span class="me-1">{{'IDS_YOU_ARE_OFFERING' | translate}}</span>
            <span class="price">{{ amount }} €</span>
        </label>
    </div>
    <div class="mt-3" *ngIf="inPreEventStatus">
        <small><b>{{'IDS_PRE_EVENT_AUCTION_REMINDER' | translate}}</b></small>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <button class="btn-confirm text-uppercase fw-bold px-3" [class.btn-gold]="!inPreEventStatus" [class.btn-preEvent]="inPreEventStatus" type="button" (click)="activeModal.close(true)">{{'IDS_CONFIRM' | translate}}</button>
    </div>
    <div class="d-flex justify-content-center my-3">
        <button class="admin-new text-uppercase fw-bold px-3" [class.preEvent]="inPreEventStatus" type="button" (click)="activeModal.close(false)">{{'IDS_BTN_ABORT' | translate}}</button>
    </div>
</div>
